import type { SharedUploaderJobSeekerResumesQuery } from "../graphql/__generated__/resumeBundles.gqlgenerated";

type ResumeBundle = NonNullable<
  SharedUploaderJobSeekerResumesQuery["jobSeekerResumes"]
>["resumes"][number];

// Picks the uploaded resume bundle to supersede. Never by list position, since bundles may be
// created by any client, and only PARSED ones come from this uploader.
export function selectUploadedResumeBundle(
  resumes: readonly ResumeBundle[] | undefined,
): ResumeBundle | undefined {
  if (!resumes?.length) {
    return undefined;
  }

  return resumes.find((bundle) => bundle.resume?.resumeType === "PARSED");
}
